import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PartnersHero from "./components/PartnersHero";
import WhyPartners from "./components/WhyPartners";
import PartnersGrid from "./components/PartnersGrid";

export default function StratejikOrtaklarimiz() {
  return (
    <main className="bg-[#F8FAFC]">
      <Navbar />
      <PartnersHero />
      <WhyPartners />
      <PartnersGrid />
      <Footer />
    </main>
  );
}
